const ComplianceSection = () => {
  return (
    <section
      id="compliance"
      data-testid="compliance-section"
      className="py-20 md:py-32 px-5 md:px-12 lg:px-20 bg-black border-t border-white/5"
    >
      <div className="max-w-6xl mx-auto">
        <div className="max-w-2xl">
          <p className="text-[#6DBE2E] text-[11px] md:text-xs font-medium tracking-[0.2em] uppercase mb-4 md:mb-6">
            Regulated Industries
          </p>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-medium text-white leading-tight tracking-tight mb-8 md:mb-10">
            We understand the rules.
          </h2>
          
          <div className="space-y-4 md:space-y-6 text-white/50 text-base md:text-lg leading-relaxed">
            <p>
              If you need sign-off before anything goes out, we build that into the process. 
              Every message, every campaign. Reviewed and approved on your terms.
            </p>
            <p>
              We generate interest. We create introductions. 
              The regulated work stays exactly where it belongs: with you.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ComplianceSection;
